import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { subscribe } from '../../../SocketIo/Socket'
import TaskList from './TaskList'
import TaskFormModal from './TaskFormModal'

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16
}

const TaskPanel = (props) => {
  const { projectId, url, user } = props
  const [tasks, setTasks] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)
  const [editingTask, setEditingTask] = React.useState(null)

  const fetchTasks = React.useCallback(() => {
    setLoading(true)
    axios.get(`${url}/api/bid-estimation/projects/${projectId}/tasks`).then(res => {
      setTasks(res.data)
      setLoading(false)
    }).catch(err => {
      console.error('Failed to fetch tasks:', err)
      setLoading(false)
    })
  }, [url, projectId])

  React.useEffect(() => {
    fetchTasks()
  }, [fetchTasks])

  // Socket subscription for real-time updates
  React.useEffect(() => {
    if (!user?._id) return
    const cleanup = subscribe(`${user._id}_tasks`, (data) => {
      if (data?.type === 'bid_notification' && data?.notification?.project?.toString() === projectId) {
        fetchTasks()
      }
    })
    return cleanup
  }, [user?._id, projectId, fetchTasks])

  const handleStatusChange = (taskId, newStatus) => {
    // Optimistic update
    setTasks(prev => prev.map(t => t._id === taskId ? { ...t, status: newStatus } : t))
    axios.put(`${url}/api/bid-estimation/tasks/${taskId}/status`, { status: newStatus })
      .then(res => {
        setTasks(prev => prev.map(t => t._id === taskId ? res.data : t))
      })
      .catch(err => {
        console.error('Status update failed:', err)
        fetchTasks() // Revert on error
      })
  }

  const handleSave = (body, taskId) => {
    const request = taskId
      ? axios.put(`${url}/api/bid-estimation/tasks/${taskId}`, body)
      : axios.post(`${url}/api/bid-estimation/projects/${projectId}/tasks`, body)

    request.then(() => {
      setModalOpen(false)
      setEditingTask(null)
      fetchTasks()
    }).catch(err => {
      console.error('Task save failed:', err)
    })
  }

  const handleEdit = (task) => {
    setEditingTask(task)
    setModalOpen(true)
  }

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>Tasks</Typography>
        <Button size="small" startIcon={<AddIcon />} onClick={() => { setEditingTask(null); setModalOpen(true) }}
          style={{ textTransform: 'none', fontSize: 12 }}>
          New Task
        </Button>
      </div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
          <CircularProgress size={20} />
        </div>
      ) : (
        <TaskList tasks={tasks} onEdit={handleEdit} onStatusChange={handleStatusChange} />
      )}
      <TaskFormModal
        open={modalOpen}
        onClose={() => { setModalOpen(false); setEditingTask(null) }}
        onSave={handleSave}
        task={editingTask}
        projectId={projectId}
        url={url}
        users={props.users || []}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  users: state.users || []
})

export default connect(mapStateToProps)(TaskPanel)
